export default "__VITE_ASSET__CtFfJ2jc__"